import React from "react";
// import { Link } from "react-router-dom";
import "./styles/Diets.css";

function Diets() {
  return (
    <div className="Diets">
      <h1 className="HeadingTop">
        <font color="#ffc400">D</font>iet <font color="#ffc400">P</font>lans{" "}
        <font color="#ffc400">F</font>or <font color="#ffc400">7</font>{" "}
        <font color="#ffc400">D</font>ays
      </h1>
      <div class="d-flex justify-content-center mt-4">
        <hr className="lineTop"></hr>
      </div>
      <img
        src="https://images.unsplash.com/photo-1546793665-c74683f339c1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80"
        alt=""
        id="imageTop"
      ></img>
      <p className="paraTop">
        <font color="#fff">With regards to sustenance,</font> things can turn
        out to be excessively confounded. In any case, unmistakably nourishment
        colossally affects the advancement that you make in the rec center. This
        page will feature various contemplations that should be made and applied
        to achieve considerable changes. Likewise, it will likewise fill in as
        an asset and feature the supplement rich food varieties that one ought
        to fuse in their day by day rec center eating regimen plan.
      </p>
      <div class="d-flex justify-content-center mt-4">
        <hr className="lineTop"></hr>
      </div>
      <h3 className="HeadingMid">
        <font color="#ffc400">F</font>oods <font color="#ffc400">T</font>o Add{" "}
        <font color="#ffc400">T</font>o <font color="#ffc400">Y</font>our{" "}
        <font color="#ffc400">G</font>ym <font color="#ffc400">D</font>iet{" "}
        <font color="#ffc400">P</font>lan
      </h3>
      <p className="paraTop">
        <font color="#fff">There are mainly three macronutrients</font> that
        play a crucial role in maintaining bodily functions and even promote
        changes in strength and composition – they are carbs, proteins, and fats
        and it is essential that we consume all three macros in ample quantities
        to optimize progress accordingly. Let’s see what are the vital nutrients
        you must include in your gym diet plan for muscle gain and weight loss.
      </p>
      <div className="Content-Mid">
        <div className="Nutrients">
          <h3 className="SubHeadingMid">
            <font color="#ffc400">C</font>arbohydrates
          </h3>
          <img
            src="https://media.istockphoto.com/photos/best-sources-of-carbs-picture-id1305234554?k=20&m=1305234554&s=612x612&w=0&h=nasbynhVfKeq4TmEUxUg-VxWazWMCl0JrJgzatppURw="
            alt=""
            id="imageMid"
          ></img>
          <p className="paraMid">
            <font color="#fff">First and foremost,</font> starches are the
            essential wellspring of energy for the body and along these lines
            assume the most significant part in powering exercise. There are two
            distinct kinds of sugars for example intricate and basic. The names
            give a sign of the time taken to process complex carbs that require
            some investment period to process than straightforward carbs. <br />
            Besides, complex starches give the body delayed sluggish arrival of
            energy and have an incredible dietary advantage. While basic
            starches give the body a present moment, quick delivering energy,
            they contain minimal healthy benefit. <br />
            Thusly, you ought to burn-through complex starches for instance
            entire grains, beans, nuts, natural products, and vegetables for
            keeping an appropriate exercise center eating routine arrangement.
          </p>
        </div>
        <div className="Nutrients">
          <h3 className="SubHeadingMid">
            <font color="#ffc400">P</font>rotein
          </h3>
          <img
            src="https://media.istockphoto.com/photos/vegan-protein-sources-picture-id909946486?k=20&m=909946486&s=612x612&w=0&h=Y9bflQNnBX8dgRDZTsdU1R1hGh7e6loLl3LOupPjZvE="
            alt=""
            id="imageMid"
          ></img>
          <p className="paraMid">
            <font color="#fff">In particular,</font> most of exercise center
            participants will be very much aware that devouring protein is
            significant. Similarly, the motivation behind why protein is so
            significant is on the grounds that it assumes a vital part in
            recuperation and fix. An exercise center eating regimen plan should
            incorporate protein. During exercise, the body is presented to
            strains and stresses. This reason harm to happen to the muscles at
            an infinitesimal level. Thus, to fix the harm, protein is required.
            Without it, recuperation periods will be expanded and constant
            exhaustion might turn into a factor. Protein is found most
            profoundly in creature produce like lean meats, eggs and dairy.
            Likewise, it can likewise be found in more modest amounts in food
            sources like seeds, nuts, vegetables, beans, and soy.
          </p>
        </div>
        <div className="Nutrients">
          <h3 className="SubHeadingMid">
            <font color="#ffc400">F</font>ats
          </h3>
          <img
            src="https://media.istockphoto.com/photos/food-background-high-in-healthy-fats-picture-id928021500?k=20&m=928021500&s=612x612&w=0&h=QwBG84C2_OWO6UIFzlC-w7Xfl8q1JS_Y4FjeT2_qCyQ="
            alt=""
            id="imageMid"
          ></img>
          <p className="paraMid">
            <font color="#fff">
              Fats are often incorrectly seen as the primary reason for fat
              gain.
            </font>{" "}
            However, fats are not responsible for this and actually play a key
            role in the absorption and transport of nutrients. In addition, they
            can have a positive impact on heart health and hormone production.
            While fats can have a positive impact on health, there are several
            types of fat – some of which are of greater benefit than others in
            gym diet plans. Recently studies have shown that saturated fats are
            not as harmful as once believed, you should mainly focus primarily
            on unsaturated fats. Examples of unsaturated fat foods include
            avocados, seeds, nuts, peanut butter, fish (salmon, tuna, mackerel),
            oils (olive, peanut), and soy products that you can include in your
            gym diet plan.
          </p>
        </div>
        <div class="d-flex justify-content-center mt-4">
          <hr className="lineTop"></hr>
        </div>
        <div className="Nutrients">
          <h4 className="SubHeadingMid">
            <font color="#ffc400">O</font>ptimal <font color="#ffc400">7</font>
            -day <font color="#ffc400">G</font>ym <font color="#ffc400">D</font>
            iet <font color="#ffc400">P</font>lan
          </h4>
          <img
            src="https://media.istockphoto.com/photos/healthy-eating-diet-and-detox-dumbbells-kiwi-water-picture-id621507002?k=20&m=621507002&s=612x612&w=0&h=tl-LPLEp9d9AOh-pxhowA2gvaZVQOL4XagQnEDXLxx4="
            alt=""
            id="imageMid"
          ></img>
          <p className="paraMid">
            <font color="#fff">
              While calories and macronutrients are significant,
            </font>{" "}
            the ideal exercise center eating regimen should be one that
            decidedly impacts wellbeing. This is an eating regimen that is
            plentiful in nutrients and minerals where each of the three
            macronutrients are devoured and supplement meager food varieties are
            confined. <br />
            <br /> <font color="#fff">In the interim,</font> how about we track
            down a 7-day rec center eating routine arrangement for you:
          </p>
        </div>
        <center>
          <h5 className="SubHeadingMid">Day 1</h5>
          <div class="row1 row row-cols-2">
            <div class="col">
              <font color="#ffc400">Breakfast</font>
            </div>
            <div class="col">Oats Banana Pancakes with Protein Shake</div>
            <div class="col">
            
              <font color="#ffc400"><hr />Lunch</font>
            </div>
            <div class="col">
            <hr />
              Multigrain roti along with palak chicken and Avocado bell pepper
              salad
            </div>
            <div class="col">
            
              <font color="#ffc400"><hr />Pre-Workout Snack</font>
            </div>
            <div class="col">
            <hr />Bananas</div>
            <div class="col">
            
              <font color="#ffc400"><hr />Dinner(Post-Workout)</font>
            </div>
            <div class="col">
            <hr />
              Brown rice, peas paneer curry, sprouts vegetable salad
            </div>
          </div>
          <h5 className="SubHeadingMid">Day 2</h5>
          <div class="row1 row row-cols-2">
            <div class="col">
              <font color="#ffc400">Breakfast</font>
            </div>
            <div class="col">
             <hr />
              Oatmeal with Greek Yogurt & Seasonal fruits Mango Juice
            </div>
            <div class="col">
              <font color="#ffc400"><hr />Lunch</font>
            </div>
            <div class="col"><hr />Multigrain roti, fish curry, vegetable salad</div>
            <div class="col">
              <font color="#ffc400"><hr />Pre-Workout Snack</font>
            </div>
            <div class="col"><hr />Toast with Jam</div>
            <div class="col">
              <font color="#ffc400"><hr />Dinner(Post-Workout)</font>
            </div>
            <div class="col">
              <hr />Broken wheat khichidi along with carrot raita, egg white, and
              vegetable salad
            </div>
          </div>
          <h5 className="SubHeadingMid">Day 3</h5>
          <div class="row1 row row-cols-2">
            <div class="col">
              <font color="#ffc400">Breakfast</font>
            </div>
            <div class="col">Poached Eggs Whole Grain Toast Protein Shake</div>
            <div class="col">
              <font color="#ffc400"><hr />Lunch</font>
            </div>
            <div class="col"><hr />Quinoa upma, chicken and broccoli salad</div>
            <div class="col">
              <font color="#ffc400"><hr />Pre-Workout Snack</font>
            </div>
            <div class="col"><hr />Mixed Nuts & Dried Fruits</div>
            <div class="col">
              <font color="#ffc400"><hr />Dinner(Post-Workout)</font>
            </div>
            <div class="col">
              <hr />Lean Meat and vegetable curry, brown rice, cucumber raita Baby
              Potatoes Chocolate Milk
            </div>
          </div>
          <h5 className="SubHeadingMid">Day 4</h5>
          <div class="row1 row row-cols-2">
            <div class="col">
              <font color="#ffc400">Breakfast</font>
            </div>
            <div class="col">Oatmeal with Honey Apple Juice</div>
            <div class="col">
              <font color="#ffc400"><hr />Lunch</font>
            </div>
            <div class="col"><hr />Grilled Chicken Salad Whole Grain Bread</div>
            <div class="col">
              <font color="#ffc400"><hr />Pre-Workout Snack</font>
            </div>
            <div class="col"><hr />Toast with Peanut Butter</div>
            <div class="col">
              <font color="#ffc400"><hr />Dinner(Post-Workout)</font>
            </div>
            <div class="col">
              <hr />Methi Chicken Brown Rice Broccoli Protein Shake
            </div>
          </div>
          <h5 className="SubHeadingMid">Day 5</h5>
          <div class="row1 row row-cols-2">
            <div class="col">
              <font color="#ffc400">Breakfast</font>
            </div>
            <div class="col">Scrambled Egg Whole Grain Toast Smoothie</div>
            <div class="col">
              <font color="#ffc400"><hr />Lunch</font>
            </div>
            <div class="col">
              <hr />Grilled chicken vegetable roti rolls Green Salad
            </div>
            <div class="col">
              <font color="#ffc400"><hr />Pre-Workout Snack</font>
            </div>
            <div class="col"><hr />Mixed Nuts & Dried Fruits</div>
            <div class="col">
              <font color="#ffc400"><hr />Dinner(Post-Workout)</font>
            </div>
            <div class="col">
              <hr />Chicken Stir Fry Spring Onion, Peppers & Broccoli Chocolate Milk
            </div>
          </div>
          <h5 className="SubHeadingMid">Day 6</h5>
          <div class="row1 row row-cols-2">
            <div class="col">
              <font color="#ffc400">Breakfast</font>
              
            </div>
            
            <div class="col">Oatmeal Whole Grain Toast Orange Juice</div>
            
            <div class="col">
            <hr />
              <font color="#ffc400">Lunch</font>
            </div>
            <div class="col">
            <hr />
              Whole Grain Chicken Wrap Black Beans, Peppers & Greek Yogurt
            </div>
            <div class="col">
            <hr />
              <font color="#ffc400">Pre-Workout Snack</font>
            </div>
            <div class="col"><hr />Apple with peanut butter</div>
            <div class="col">
            <hr />
              <font color="#ffc400">Dinner(Post-Workout)</font>
            </div>
            <div class="col">
            <hr />
              Keema bhurji and multigrain roti Lean Mutton Mince Sweet Potato
              Protein Shake
              
            </div>
          </div>
          <h5 className="SubHeadingMid">Day 7</h5>
          <div class="row1 row row-cols-2">
            <div class="col">
              <font color="#ffc400">Breakfast</font>
            </div>
            <div class="col">Oatmeal with Nuts Smoothie</div>
            <div class="col">
              <font color="#ffc400"><hr />Lunch</font>
            </div>
            <div class="col">
             <hr /> Whole wheat pasta with chicken and Green Salad
            </div>
            <div class="col">
              <font color="#ffc400"><hr />Pre-Workout Snack</font>
            </div>
            <div class="col"><hr />Granola or Cereal</div>
            <div class="col">
              <font color="#ffc400"><hr />Dinner(Post-Workout)</font>
            </div>
            <div class="col">
              <hr />Fish curry, boiled green peas salad Brown Rice Garden Peas Milk
            </div>
          </div>
        </center>
      </div>
    </div>
  );
}

export default Diets;
